const mobileNumber = /^[0-9]*$/

export const regex = {
 mobileNumber,
 numeric: /^[0-9]*$/,
 alphanumeric: /^\d*[a-zA-Z][a-zA-Z0-9]*$/
}

export const lengths = {
 otp: 6
}